import React, { useEffect } from "react";
import { useParams } from "react-router";
import { axiosInstance } from "utils/axios";
import {
  Box,
} from "@chakra-ui/react";

const DownloadFile = () => {
  const { id: reviewId, filename } = useParams();
  
  console.log(reviewId);
  useEffect(() => {
    if (reviewId) {
      axiosInstance
        .get(`/articles/${reviewId}/downloadFileReview`, {
          responseType: "blob",
        })
        .then(async (_res) => {
          const url = window.URL.createObjectURL(new Blob([_res.data]));
          const link = document.createElement("a");
          link.href = url;            
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          alert("Download file success!");
        })
        .catch((err) => console.log(err));
    }
  }, [reviewId]);

  return (
    <Box>
      Thanks for download!
    </Box>
  );
};

export default DownloadFile;
